// @ts-nocheck
/*
Componente criado para realizar upload de arquivos utilizando a biblioteca FilePond.
Para utilizar o componente basta especificar os seguintes parametros:

- aspectRatio: determina o tamanho da imagem de preview a ser exibida;
	ex: aspectRatio={0.2}

- label: label que será mostrada no componente antes da seleção de arquivos
	ex: 'Arraste & Solte ou clique para selecionar um arquivo'

- allowMultiple: variavel que permite multiplos arquivos a serem selecionados

- maxFiles: determina o numero maximo de arquivos que podem ser selecionados,
por padrão foi setado como 1;

- onUpload: função para realizar o upload de arquivos;
	ex: função onDrop da tela cadastro Analise;

- valuesFormik: valores do estado do formik;

- name: nome do componente;

- acceptedFileTypes: tipos de arquivos que serão aceitos
	ex: acceptedFileTypes={ [ 'image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/tiff',]}

- expetedTypesLabel: string para label utilizada na validação dos tipos aceitos, será mostrada em
caso de algum arquivo não aceito ser submetido para o componente;

- context: contexto this da aplicação, utilizado para acessar metodos
como this.setState e this.state;

Para mais detalhes acesse a documentação do FilePond:
https://pqina.nl/filepond/docs/print-version/#react
https://pqina.nl/filepond/docs/patterns/installation/

*/

/*
Plugins utilizados pelo FilePond

Todos os plugins disponiveis estão listados na documentação oficial do filePond:
https://pqina.nl/filepond/plugins.html
 */
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import React from 'react';
import { FilePond, registerPlugin } from 'react-filepond';

registerPlugin(
	FilePondPluginImageExifOrientation,
	FilePondPluginImagePreview,
	FilePondPluginFileValidateType,
	FilePondPluginFileValidateSize,
);

function UploadBrowseFile(props) {
	const {
		aspectRatio,
		label,
		allowMultiple,
		maxFiles,
		onUpload,
		valuesFormik,
		name,
		acceptedFileTypes,
		expetedTypesLabel,
		context,
		handleRemoveFile,
	} = props;
	const {
		state: { files },
	} = context;
	return (
		<React.Fragment>
			<FilePond
				files={files}
				name={name}
				maxFiles={maxFiles || 1}
				maxFileSize='10MB'
				allowMultiple={allowMultiple}
				acceptedFileTypes={acceptedFileTypes}
				labelFileTypeNotAllowed='O Tipo de arquivo selecionado é inválido.'
				labelMaxFileSizeExceeded='Documento selecionado excede o tamanho máximo'
				labelMaxFileSize='Tamanho máximo do documento para upload é 10mb'
				fileValidateTypeLabelExpectedTypesMap={acceptedFileTypes}
				fileValidateTypeLabelExpectedTypes={expetedTypesLabel}
				labelIdle={label || 'Arraste e solte aqui a imagem ou <span class="filepond--label-action">clique</span> selecionar uma imagem.'}
				styleItemPanelAspectRatio={aspectRatio || null}
				onaddfilestart={(fileItem) => {
					context.setState({
						files: [fileItem],
					});
					if (acceptedFileTypes.includes(fileItem.fileType)) {
						onUpload([fileItem], valuesFormik);
					}
				}}
				onremovefile={handleRemoveFile}
			/>
		</React.Fragment>
	);
}

export default UploadBrowseFile;
